import instance from "../../utils/axios"; // same axios instance

const BASE_URL = "/churches/carecells/coverimage";

// ✅ Save Cover Image
export const saveCoverImage = async (payload) => {
  const required = ["_id", "carecellObjId", "galleryObjId"];
  required.forEach((key) => {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  });

  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, value]) =>
    formData.append(key, value ?? "")
  );

  const response = await instance.post(`${BASE_URL}/save`, formData);
  return response.data;
};

// ✅ Update Cover Image
export const updateCoverImage = async (payload) => {
  const required = ["_id", "carecellObjId", "galleryObjId"];
  required.forEach((key) => {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  });

  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([key, value]) =>
    formData.append(key, value ?? "")
  );

  const response = await instance.post(`${BASE_URL}/update`, formData);
  return response.data;
};
export const deleteCoverImage = async (payload) => {

  // ✅ Extract apiPayloadRequest if it's nested
  const data = payload?.apiPayloadRequest || payload;

  // ✅ Validate required fields
  const required = ["_id", "carecellObjId", "carecellCoverImageObjId"];
  required.forEach((key) => {
    if (!data[key]) throw new Error(`Missing field: ${key}`);
  });

  // ✅ Build form data
  const formData = new URLSearchParams();
  Object.entries(data || {}).forEach(([key, value]) => {
    formData.append(key, value ?? "");
  });

  // ✅ Make API call
  const response = await instance.post(`${BASE_URL}/delete`, formData);
  return response.data;
};
